import React from 'react';
import './radio-button.scss';

interface RadioInputProps {
    id: string;
    label: string;
    groupValue?: string | null | undefined;
    onChange?: (value?: any) => void;
    name?: string;
    value?: any;
    testId?: string;
}

const RadioInput: React.FC<RadioInputProps> = ({ id, name, label, value, testId, groupValue, onChange }) => {
    const [isChecked, setIsChecked] = React.useState(groupValue === value);

    React.useEffect(() => {
        setIsChecked(groupValue === value);
        return;
    }, [groupValue, value])

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        handleClick();
    };

    const handleClick = () => {
        if (onChange) {
            onChange(value);
        }
        setIsChecked(true);
    };

    const handleLabelClick = (e: React.MouseEvent<HTMLLabelElement>) => {
        e.preventDefault();
        handleClick();
        return;
    };

    return (
        <div className="radio" onClick={handleClick}
            style={{
                backgroundColor: `rgb(${isChecked ? '172, 226, 228' : '255, 255, 255'})`,
                border: `1px solid rgb(${isChecked ? '172, 226, 228' : '255, 255, 255'})`,
            }}>
            <input
                className="radio__input"
                type="radio"
                id={id}
                name={name}
                value={value}
                data-testid={testId}
                checked={isChecked}
                onChange={handleChange}
            />
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 5 5"
                className={'radio__svg'}
                style={{ opacity: isChecked ? 1 : 0 }}
                aria-hidden="true">
                <path fill="currentColor" d="M0 2.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0z" />
            </svg>
            <label className="radio__label" htmlFor={id} onClick={handleLabelClick} style={{ color: `rgb(${isChecked ? '26, 50, 102' : '0, 0, 0'})` }}>{label}</label>
        </div>
    );
};

export default RadioInput;